import { mapUserAssistanceIPFromApiToVM, UserAssistanceIP } from '../domain';
import { globalGraphqlRequest } from 'core/utils/backend-service';
import { getUserAssistanceIPQuery } from './user-assistance-ip.queries';

export const getUserAssistanceIP = (): Promise<UserAssistanceIP> =>
    globalGraphqlRequest(getUserAssistanceIPQuery()).then((response) =>
        mapUserAssistanceIPFromApiToVM(response.data.npocoEdgeIp)
    );
